import {isAssignedTickets, isTicketed} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {useAppSelector} from '../../hooks/runtime'
import {getBuyerDetails} from '../../selectors/checkout'
import {getDefaultFormValues} from '../../selectors/current-member-details'
import {getEvent} from '../../selectors/event'
import {getPlacedOrder} from '../../selectors/placed-order'
import {getRsvpDetails} from '../../selectors/rsvp'
import c from '../classnames.scss'
import {DISABLED_PREFILLED_FORM_FIELDS} from '../form/constants'
import {Form} from '../form/container'
import s from './buyer-details.scss'
import {BuyerDetailsProps} from './interfaces'
import {getInitialValues} from './utils'

export const BuyerDetails = ({editing, onSubmit}: BuyerDetailsProps) => {
  const buyerDetails = useAppSelector(getBuyerDetails)
  const rsvpDetails = useAppSelector(getRsvpDetails)
  const defaultFormValues = useAppSelector(getDefaultFormValues)
  const placedOrder = useAppSelector(getPlacedOrder)
  const event = useAppSelector(getEvent)

  const ticketed = isTicketed(event)
  const initialValues = getInitialValues({ticketed, buyerDetails, rsvpDetails, defaultFormValues, order: placedOrder})
  const disabledFields = initialValues.email ? DISABLED_PREFILLED_FORM_FIELDS : []
  const details = ticketed ? buyerDetails : rsvpDetails
  const assignedTicketsEnabled = ticketed && isAssignedTickets(event)

  return editing ? (
    <div className={s.container}>
      <Form
        initialValues={initialValues}
        disabledFields={disabledFields}
        hideAdditionalFields={assignedTicketsEnabled}
        onFormSubmit={onSubmit}
      />
    </div>
  ) : (
    <div
      data-hook={DH.CHECKOUT_BUYER_DETAILS}
      className={classNames(s.details, c.formLabelsFont, c.formLabelsColor, s.opaque)}
    >
      <div>
        {details.firstName} {details.lastName}
      </div>
      <div>{details.email}</div>
    </div>
  )
}
